import script from "./BottleBotWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./BottleBotWidget.vue?vue&type=script&setup=true&lang=js"

import "./BottleBotWidget.vue?vue&type=style&index=0&id=d1239e3a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.38_vue@3.5.38_webpack@5.107.2_postcss@8.5.15_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d1239e3a"]])

export default __exports__

/* vue-cli-plugin-import-components */

import BotComposer from "@/components/catering/bottleBot/BotComposer.vue";
import BotHeader from "@/components/catering/bottleBot/BotHeader.vue";
import BotHistory from "@/components/catering/bottleBot/BotHistory.vue";
import BotMessageList from "@/components/catering/bottleBot/BotMessageList.vue";
script.components = Object.assign({}, { BotComposer, BotHeader, BotHistory, BotMessageList }, script.components);if ('__vccOpts' in script) { script.__o = script.__o || {}; script.__o.components = Object.assign({}, { BotComposer, BotHeader, BotHistory, BotMessageList }, script.__o.components);}